if (!customElements.get('continuos-scroll')) {
  class ContinuosScroll extends HTMLElement {
    constructor() {
      super();
      this.itemsContainer = this.querySelectorAll('.scroll-items-container');
      this.init();
    }

    init() {
      this.addEventListener('touchstart', this.togglePlayAndPause);
      this.addEventListener('touchend', this.togglePlayAndPause);
    }

    togglePlayAndPause(event) {
      this.itemsContainer.forEach((container) => {
        container.style.animationPlayState =
          event.type === 'touchstart' ? 'paused' : 'running';
      });
    }
  }

  customElements.define('continuos-scroll', ContinuosScroll);
}
